export class UCSDKService {
  getTopic = (channelName, topicName) => {
    return window.uc?.channels[channelName]?.topics[topicName];
  };

  getTopicAsync = async (channelName, topicName) => {
    await window.libraryManager?.UCSDKLibrary;
    return window.uc?.channels[channelName]?.topics[topicName];
  };

  getB2CCookieContainerIdAsync = async () => {
    await window.libraryManager?.UCSDKLibrary;
    return window.uc.b2c?.getCookieContainer();
  };

  findIfIsUserEligibleAsync = async featureName => {
    await window.libraryManager?.UCSDKLibrary;
    return await window.uc.feature?.isUserEligible(featureName);
  };

  getActiveAbTestFeaturesAsync = async featureTestId => {
    await window.libraryManager?.UCSDKLibrary;
    return await window.uc.feature?.getActiveAbTestFeatures(featureTestId);
  };

  checkEnvAuthPasswordAsync = async password => {
    await window.libraryManager?.UCSDKLibrary;
    return await window.uc.envAccessAuthFunctions?.checkPassword(password);
  };

  clearNativeDataStore = async () => {
    await window.libraryManager?.UCSDKLibrary;
    window.NativeInterface?.clearNativeDataStore();
  };

  updateNativeDataStore = async () => {
    await window.libraryManager?.UCSDKLibrary;
    window.NativeInterface?.updateNativeDataStore();
  };
}
